import React from "react";
import GSHTMLViewer from "../../components/gs-html-viewer";
import { defaultPadding, defaultTheme } from "../../helpers/Theme";

export default {
  title: "controls/GS HTML Viewer",
  component: GSHTMLViewer,
  argTypes: {
    html: {
      description: "html string"
    },
    style: {
      description: "html Viewer styling"
    }
  }
};

const Template = args => (
  <div style={{ width: "100%" }}>
    <GSHTMLViewer {...args} />
  </div>
);

export const HTMLViewer = Template.bind({});
HTMLViewer.args = {
  html:
    '<div style="display: inline-flex; flex-direction: column"> <h1>This is HTML</h1> <h2>you can put any html you want in this</h2> <h3>It displays html</h3> <input value="That is what it does"></input> </div>',
  style: { ...defaultPadding.xLargePad, ...defaultTheme.surfaceVariant.light }
};
